import React from 'react';
import { t } from 'i18next';

export const formatCpf = cpf => (/^\d{11}$/.test(cpf || '') ? cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4') : cpf || '');

// CPF placeholder usado quando o aluno nao tem CPF cadastrado -- nesse caso
// nao faz sentido imprimir "000.000.000-00" (parece um CPF valido), so' a
// sigla em vermelho pra sinalizar que falta cadastrar.
const BLANK_CPF = '000.000.000-00';

const field = (label, value) => (value ? `${label.replace(/:$/, '')}: ${value}` : label);

export default function IdentificationForm({ student, series, school, classGroup, minimal = false }) {
  const formattedCpf = formatCpf(student?.cpf);
  const isBlankCpf = formattedCpf === BLANK_CPF;

  return (
    <div className="printed-exam__form">
      <div className="printed-exam__form-row">
        <p
          className="printed-exam__form-control"
          style={{ flexGrow: 3 }}
        >
          {field(t('textsCommon.name'), student?.name)}
        </p>
        <p className="printed-exam__form-control">
          {isBlankCpf ? <span style={{ color: 'red' }}>{field(t('exams.cpf'))}</span> : field(t('exams.cpf'), formattedCpf)}
        </p>
      </div>
      {minimal && (
        <div className="printed-exam__form-row">
          <p className="printed-exam__form-control">{field(t('exams.seriesCourse'), series)}</p>
          <p className="printed-exam__form-control">{field('Escola', school)}</p>
          <p className="printed-exam__form-control">{field(t('exams.classModule'), classGroup)}</p>
        </div>
      )}
      {!minimal && (
        <>
          <div className="printed-exam__form-row">
            <p className="printed-exam__form-control">{field('Nº', student?.ra)}</p>
            <p className="printed-exam__form-control">{field(t('exams.seriesCourse'), series)}</p>
            <p className="printed-exam__form-control">{field(t('exams.classModule'), classGroup)}</p>
            <p className="printed-exam__form-control">{t('exams.shift')}</p>
          </div>
          <div className="printed-exam__form-row">
            <p className="printed-exam__form-control printed-exam__form-control--50">{t('textsCommon.teacher')}</p>
            <p className="printed-exam__form-control printed-exam__form-control--50">{t('exams.subject')}</p>
          </div>
        </>
      )}
    </div>
  );
}
